import React from "react";
import InputMask from "react-input-mask";
import { Input } from "@chakra-ui/react";

export interface RangeDateInputProps {
  name?: string;
  value?: string;
  onChange?: (value: string | null) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

export const RangeDateInput = React.forwardRef<
  HTMLInputElement,
  RangeDateInputProps
>(({ name, placeholder, value, onChange, onFocus }, ref) => {
  return (
    <Input
      w={"50%"}
      name={name}
      inputRef={ref}
      as={InputMask}
      mask={"99/99/9999"}
      value={value}
      _focus={{
        borderColor: "brand.main",
        color: "black",
      }}
      bg="white"
      focusBorderColor="brand.main"
      height="none"
      borderRadius={4}
      borderColor="border.input"
      fontFamily="Nunito Sans"
      pt="12px"
      pb="12px"
      fontSize="md"
      color="black"
      placeholder={"MM/DD/YYYY" || placeholder}
      onChange={(e) => onChange?.(e.target.value)}
      onFocus={onFocus}
      border={0}
    />
  );
});

RangeDateInput.displayName = "RangeDateInput";
